// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user_donation_details {
  margin-top: 30px;
  width: 90%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100% !important;
  margin-bottom: 20px;
}
.user_donation_main_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  align-items: center;
}

.pagination_mobile_container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-bottom: 10px;
  padding-right: 10px;
}
.donation_mobile_main_container {
  padding: 20px;
}
.donation_mobile_container {
  padding: 30px;
}
.no_donation_container {
  height: 400px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

@media only screen and (min-width: 0px) and (max-width: 500px) {
  .donation_mobile_main_container {
    display: block !important;
  }
  .user_donation_details {
    display: none;
  }

  table {
    border-collapse: collapse;
    font-family: Arial, sans-serif;
    font-size: 14px;
  }

  tbody tr:nth-child(odd) {
    background-color: #f9f9f9;
  }

  tbody tr:nth-child(even) {
    background-color: #fff;
    border: 1px solid black !important;
  }

  td {
    padding: 8px;
    text-align: center;
  }

  td:first-child {
    font-weight: bold;
    background-color: #f2f2f2;
    border: 1px solid #ddd;
  }

  tbody tr:hover {
    background-color: #f1f1f1;
  }
}
@media only screen and (min-width: 501px) and (max-width: 5000px) {
  .donation_mobile_main_container {
    display: none !important;
  }
  .donation_mobile_container {
    display: none;
  }
}

.custom_modal {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.custom_modal .ant-modal-content {
  display: flex;
  padding: 0px !important;
  align-items: center;
  width: 350px;
}

.modal_header {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
  background-color: var(--background-theme-color);
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.modal_header h2 {
  font-size: 18px;
  font-weight: bold;
  color: #fff;
}
.custom_donation_form {
  width: 350px;
  padding-left: 20px;
  padding-right: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/user_donation.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".user_donation_details {\n  margin-top: 30px;\n  width: 90%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  height: 100% !important;\n  margin-bottom: 20px;\n}\n.user_donation_main_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  align-items: center;\n}\n\n.pagination_mobile_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  padding-bottom: 10px;\n  padding-right: 10px;\n}\n.donation_mobile_main_container {\n  padding: 20px;\n}\n.donation_mobile_container {\n  padding: 30px;\n}\n.no_donation_container {\n  height: 400px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n@media only screen and (min-width: 0px) and (max-width: 500px) {\n  .donation_mobile_main_container {\n    display: block !important;\n  }\n  .user_donation_details {\n    display: none;\n  }\n\n  table {\n    border-collapse: collapse;\n    font-family: Arial, sans-serif;\n    font-size: 14px;\n  }\n\n  tbody tr:nth-child(odd) {\n    background-color: #f9f9f9;\n  }\n\n  tbody tr:nth-child(even) {\n    background-color: #fff;\n    border: 1px solid black !important;\n  }\n\n  td {\n    padding: 8px;\n    text-align: center;\n  }\n\n  td:first-child {\n    font-weight: bold;\n    background-color: #f2f2f2;\n    border: 1px solid #ddd;\n  }\n\n  tbody tr:hover {\n    background-color: #f1f1f1;\n  }\n}\n@media only screen and (min-width: 501px) and (max-width: 5000px) {\n  .donation_mobile_main_container {\n    display: none !important;\n  }\n  .donation_mobile_container {\n    display: none;\n  }\n}\n\n.custom_modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.custom_modal .ant-modal-content {\n  display: flex;\n  padding: 0px !important;\n  align-items: center;\n  width: 350px;\n}\n\n.modal_header {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  margin-bottom: 20px;\n  background-color: var(--background-theme-color);\n  align-items: center;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.modal_header h2 {\n  font-size: 18px;\n  font-weight: bold;\n  color: #fff;\n}\n.custom_donation_form {\n  width: 350px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
